module.exports = __webpack_public_path__ + "img/image-1.5dbb00c9.jpg";